import '../../../styles/supervise.scss';
import './index.scss';
import React from 'react';
import { useHistory } from 'react-router';
import sysConfig from '../../../sysConfig';
import { checkLogin } from '../../../utils';

function InstructionalSupervision() {
  const history = useHistory();
  const { preRouteUrl } = sysConfig;
  const columns = [
    { key: 'realTimeSupervise', title: '实时督导' },
    { key: 'afterClassSupervise', title: '课后督导' },
    { key: 'superviseQuery', title: '督导查询' },
    { key: 'anomalyTracing', title: '异常追溯' },
    { key: 'superviseStatistics', title: '督导统计' },
  ];
  return (
    <div className="instructional-supervision">
      <div className="instructional-supervision-columns">
        {columns.map((item) => {
          return (
            <div
              className="instructional-supervision-item"
              key={item.key}
              onClick={() =>
                checkLogin({
                  onLogin: () => {
                    history.push(`${preRouteUrl}/supervise/instructionalSupervision/${item.key}`);
                  },
                })
              }
            >
              <em className={`item-icon ${item.key}`} />
              <span>{item.title}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default InstructionalSupervision;
